export const default_menus = {
  threeTabOne: true,
  threeTabTwo: true,
  hotTopic: true,
  latestArticle: true,
  sharePerk: true,
  latestPost: true,
  latestPoll: true,
  latestProduct: true,
  top10Offers: true,
  hotOffer: true,
  hotTask: true,
  hotVideo: true,
  tokenBalance: true,
  navigationTiles: true,
};
export const titles = {
  threeTabOne: "3 tab bar one",
  threeTabTwo: "3 tab bar two",
  hotTopic: "Hot Topic",
  latestArticle: "Latest Article",
  sharePerk: "Share Perk",
  latestPost: "Latest post",
  latestPoll: "Latest poll",
  latestProduct: "Latest product",
  top10Offers: "Top 10 offers",
  hotOffer: "Hot Offer",
  hotTask: "Hot Task",
  hotVideo: "Hot Video",
  tokenBalance: "Token Balance",
  navigationTiles: "Navigation tiles",
};
export const threeTabBarOneValues = {
  left: "Goals",
  middle: "Chat",
  right: "Diary",
};
export const threeTabBarTwoValues = {
  left: "Wallet",
  middle: "TokenPay",
  right: "Store",
};



// WEBPACK FOOTER //
// ./src/screens/BespokeExplore/constants/default.js